import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { EntityTypographyGroup } from 'src/editor/shared/settings/wrappers/entity-and-website-typography-group/entity-typography-group'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'
import { WebsiteLanguageSwitcherSettingsProps } from './website-language-switcher-settings'

export const WebsiteLanguageSwitcherSettingsDesign = ({
  entity,
}: WebsiteLanguageSwitcherSettingsProps) => {
  const { t } = useTranslation()
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)
  return (
    <>
      <GroupTitle withoutHorizontalLine>{t('typography')}</GroupTitle>
      <EntityTypographyGroup
        entity={entity}
        hideTitle
        isFirst
        hideTextAlign
        hideLetterSpacing={isMobile}
        hideFontSelector={isMobile}
      />
      {!isMobile && (
        <ColorPickerControl
          label="website_settings.sidebar.language_switcher.text_color"
          update={updateProp('textColor')}
          color={entity.textColor ?? ''}
          singleColorMode
          labelClassName="grow-1"
        />
      )}

      <SizeAndPositionGroup
        margin={getMobileOrDesktop(
          entity.margin,
          entity.mobileMargin,
          isMobile,
        )}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
        padding={getMobileOrDesktop(
          entity.padding,
          entity.mobilePadding,
          isMobile,
        )}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
        singleDeviceMode
      />
    </>
  )
}
